export default "__VITE_ASSET__Cipiy0LH__"